import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import _ from 'lodash';
import { ImageConstants } from '../../../../service/image-constants';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'toolPathSelector',
  templateUrl: 'toolPathSelector.html',
  styleUrls: ['toolPathSelector.scss']
})
export class ToolPathSelectorDialog {
  public toolPaths: object[];
  constructor(
    public dialogRef: MatDialogRef<ToolPathSelectorDialog>,
    public imageConstants: ImageConstants,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.toolPaths = this.data.toolPaths;
  }

  dialogSelectedToolPath = (value?: string) => {
    //pass no value and it will just be closing the dialog
    let retObj = {
      operationName: value
    };
    this.dialogRef.close(retObj);
  };
}
